import React, { useState } from 'react';

const AboutForm = ({ initialValues = { title: '', content: '' }, onSubmit, onCancel, isLoading, isEdit }) => {
  const [form, setForm] = useState(initialValues);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const errs = {};
    if (!form.title.trim()) errs.title = 'Title is required';
    if (!form.content.trim()) errs.content = 'Content is required';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    onSubmit(form);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium mb-1">Title</label>
        <input
          name="title"
          value={form.title}
          onChange={handleChange}
          className={`w-full border rounded px-3 py-2 ${errors.title ? 'border-red-400' : 'border-gray-300'}`}
          placeholder="Section title"
        />
        {errors.title && <div className="text-xs text-red-500 mt-1">{errors.title}</div>}
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Content</label>
        <textarea
          name="content"
          value={form.content}
          onChange={handleChange}
          className={`w-full border rounded px-3 py-2 min-h-[80px] ${errors.content ? 'border-red-400' : 'border-gray-300'}`}
          placeholder="Section content"
        />
        {errors.content && <div className="text-xs text-red-500 mt-1">{errors.content}</div>}
      </div>
      <div className="flex gap-2 pt-2">
        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" disabled={isLoading}>
          {isEdit ? 'Update' : 'Create'}
        </button>
        <button type="button" className="bg-gray-100 text-gray-700 px-4 py-2 rounded hover:bg-gray-200" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AboutForm; 